const isSmallDevice = () => window.matchMedia("(max-width: 768px)").matches;

export { isSmallDevice };
